import React, { useState } from "react";
import PropTypes from "prop-types";
import Wrapper from "../../assets/wrappers/JobsContainer";
import Message from "./Message";

const MessagesContainer = ({ messages: initialMessages }) => {
  const [messages, setMessages] = useState(initialMessages);
  const handleDeleteMessage = (id) => {
    setMessages((prevMessages) =>
      prevMessages.filter((message) => message._id !== id)
    );
  };

  if (messages.length === 0) {
    return (
      <Wrapper>
        <h2>לא נמצאו הודעות להציג...</h2>
      </Wrapper>
    );
  }

  //   <Message
  //   key={message._id}
  //   {...message}
  //   onDelete={handleDeleteMessage} // מעביר את הפונקציה למחיקה
  // />

  return (
    <Wrapper>
      <h3>רשימת הודעות</h3>
      <div className="messages">
        {messages.map((message) => (
          <Message
            key={message._id}
            _id={message._id}
            messageType={message.messageType}
            messageDetails={message.messageDetails}
            onDelete={handleDeleteMessage}
            buildingId={message.target.buildings[0]} // נניח שזה נשלף כראוי
          />
        ))}
      </div>
    </Wrapper>
  );
};

MessagesContainer.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      messageType: PropTypes.string.isRequired,
      messageDetails: PropTypes.object.isRequired,
    })
  ).isRequired,
};

export default MessagesContainer;

